import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@trevor/ui-components';
import { datasourceUrlPrefix, userAction } from '@/util/helpers/ajax-helpers';
import ModalContent from '../ModalContent';
import style from '../../css/module/upgrade.css';
import flex from '../../css/module/flex.css';
import { closeReactModal } from '../../actions';

class UpgradeModal extends Component {
  componentDidMount() {
    userAction('seen-alert-too_many_queries');
  }

  render() {
    const { isHeroku, onCloseModal, maxQueries } = this.props;

    const url = `${datasourceUrlPrefix()}/billing`;
    const premiumFeatures = isHeroku
      ? 'https://elements.heroku.com/addons/trevor#pricing'
      : 'https://trevor.io/pricing';

    return (
      <ModalContent extraSmall>
        <div className={style.container}>
          <h1>
            <img
              style={{ width: '30px', marginTop: '-5px' }}
              src="/img/rocket-border-full.png"
            />{' '}
            Upgrade to Pro to save more queries
          </h1>
          <p className="margin-top-20">
            Your team has saved {maxQueries}+ queries! Upgrade to{' '}
            <b>Trevor Pro</b> to save unlimited queries and unlock more{' '}
            <a href={premiumFeatures} target="_blank">
              premium features
            </a>
            .
          </p>
          <div
            className={`${flex.flex} margin-top-30 ${flex.justifyContentCenter}`}
          >
            <Button
              variant="secondary"
              onClick={onCloseModal}
              className="margin-right-10"
            >
              <b>Skip for now</b>
            </Button>
            <a href={url} target="_blank">
              <Button>
                <b>Upgrade to Pro</b>
              </Button>
            </a>
          </div>
        </div>
      </ModalContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isHeroku: state.datasource.isHerokuBeta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCloseModal: () => {
      dispatch(closeReactModal());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeModal);
